import { useQuery } from "@tanstack/react-query";
import { GET } from "@/lib/methods";
import type { FoodangoUser } from "@/types/foodango-user";

export const useFoodangoUser = ({ email }: { email?: string }) => {
  return useQuery({
    queryKey: ["foodango-user", email],
    queryFn: async () => {
      const response = await GET({
        url: "/api/user",
        params: {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      });
      return response as FoodangoUser;
    },
    enabled: !!email,
    staleTime: 1000 * 60 * 60 * 24,
  });
};
